import {
  CalendarClockIcon,
  PersonIcon,
  TrendingUpIcon,
} from 'assets/icons';
import ResultTiles from 'components/stats/ResultTiles';
import { wholeEuros } from 'pages/companies/recordItems';
import useText from 'hooks/useText';
import { RecordSection } from './RecordLayout';

/**
 * « Résultats » of the sales work with a company, the tiles of the statistics
 * page for this company alone: the appointments held, the revenue and the
 * show-up, since `since`.
 */
const ResultsCard = ({ results, since }) => {
  const { text } = useText('record');
  const tiles = [
    {
      key: 'held',
      icon: CalendarClockIcon,
      value: String(results.appointmentsHeld),
      label: text(
        results.appointmentsHeld > 1 ? 'resultsHeldMany' : 'resultsHeldOne',
      ),
    },
    {
      key: 'revenue',
      icon: TrendingUpIcon,
      value: wholeEuros(results.revenue),
      label: text('resultsRevenue'),
    },
    {
      key: 'showUp',
      icon: PersonIcon,
      value: `${results.showUp} %`,
      label: text('resultsShowUp'),
    },
  ];
  return (
    <RecordSection
      title={text('results')}
      action={<span className="text-xs text-gray-400">{since}</span>}
    >
      <ResultTiles tiles={tiles} layout="record" />
    </RecordSection>
  );
};

export default ResultsCard;
